var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.125V16.125H2.25V10.125H8.25ZM6.75 11.625H3.75V14.625H6.75V11.625ZM9 1.5L13.125 8.25H4.875L9 1.5ZM9 4.395L7.56 6.75H10.44L9 4.395ZM13.125 9.75C15 9.75 16.5 11.25 16.5 13.125C16.5 15 15 16.5 13.125 16.5C11.25 16.5 9.75 15 9.75 13.125C9.75 11.25 11.25 9.75 13.125 9.75ZM13.125 11.25C12.6277 11.25 12.1508 11.4475 11.7992 11.7992C11.4475 12.1508 11.25 12.6277 11.25 13.125C11.25 13.6223 11.4475 14.0992 11.7992 14.4508C12.1508 14.8025 12.6277 15 13.125 15C13.6223 15 14.0992 14.8025 14.4508 14.4508C14.8025 14.0992 15 13.6223 15 13.125C15 12.6277 14.8025 12.1508 14.4508 11.7992C14.0992 11.4475 13.6223 11.25 13.125 11.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeImg);
export default __webpack_public_path__ + "static/media/themeImg.5d8518bc8191d07743baa76688cca2be.svg";
export { ForwardRef as ReactComponent };